import React, { useCallback, useEffect, useState } from 'react';
import { adminAPI } from '../services/api';

export default function GroupPictureModerationPanel() {
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await adminAPI.getGroupPictureModeration();
      setCommunities(response.data.communities || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not load group pictures.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const moderate = async (community, action) => {
    const reason = action === 'reject'
      ? window.prompt('Reason for rejecting this group picture:', 'Violates image or privacy policy')
      : '';
    if (action === 'reject' && reason === null) return;
    try {
      setBusyId(community._id);
      if (action === 'approve') await adminAPI.approveGroupPicture(community._id);
      else await adminAPI.rejectGroupPicture(community._id, { reason });
      setCommunities((items) => items.filter((item) => item._id !== community._id));
    } catch (err) {
      window.alert(err.response?.data?.error || `Could not ${action} group picture.`);
    } finally {
      setBusyId('');
    }
  };

  return (
    <section>
      <div className="flex justify-between items-start mb-6">
        <div><h2 className="text-2xl font-bold">Group Picture Moderation</h2><p className="text-sm text-gray-500 mt-1">Pictures that did not automatically pass moderation.</p></div>
        <button type="button" onClick={load} className="px-4 py-2 bg-pink-500 text-white rounded-xl font-semibold">Refresh</button>
      </div>
      {error && <div className="bg-red-50 text-red-700 p-3 rounded-xl mb-4">{error}</div>}
      {loading ? <div className="text-center py-12 text-gray-500">Loading…</div> : communities.length === 0 ? <div className="bg-white border rounded-2xl text-center py-12 text-gray-500">No group pictures require review.</div> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
          {communities.map((community) => <article key={community._id} className="bg-white border rounded-2xl overflow-hidden">
            <img src={community.imageUrl} alt="" className="w-full h-56 object-cover bg-gray-100" />
            <div className="p-4">
              <div className="flex justify-between gap-2"><strong>{community.name}</strong><span className="text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full h-fit">{community.imageModerationStatus}</span></div>
              {community.description && <p className="text-sm text-gray-600 mt-2 line-clamp-3">{community.description}</p>}
              <p className="text-xs text-gray-400 mt-2">{community.imageModerationReason || 'Awaiting manual review'}</p>
              <div className="grid grid-cols-2 gap-2 mt-4">
                <button disabled={busyId === community._id} type="button" onClick={() => moderate(community, 'approve')} className="py-2 bg-green-100 text-green-700 rounded-lg font-semibold disabled:opacity-50">Approve</button>
                <button disabled={busyId === community._id} type="button" onClick={() => moderate(community, 'reject')} className="py-2 bg-red-100 text-red-700 rounded-lg font-semibold disabled:opacity-50">Reject</button>
              </div>
            </div>
          </article>)}
        </div>
      )}
    </section>
  );
}
